let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cjkeb")).then(() => parcelRequire('3jp5k'));